import React, {useEffect, useState} from "react";
import { onlineProcessesService } from "../../../../services";
import { QuadralLoaderProvider } from "@quadral/quadral-component-common/dist/components/loader/LoaderContext";
import QuadralButton from '@quadral/quadral-component-common/dist/components/button';
import QuadralTextField from '@quadral/quadral-component-common/dist/components/textField';
import QuadralAutocomplete from "@quadral/quadral-component-common/dist/components/autocomplete";
import QuadralModal from '@quadral/quadral-component-common/dist/components/modal';
import QuadralContainer from "@quadral/quadral-component-common/dist/components/container";
import QuadralForm from "@quadral/quadral-component-common/dist/components/form";
import QuadralTypography from "@quadral/quadral-component-common/dist/components/typography";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faInfoCircle } from "@fortawesome/free-solid-svg-icons";

export default function AddNewDocumentModal ({open, setOpen, handlePageAssignment, setSelectedFileByDoc, dataUrlToFile, receptionBoxDisplay, unassignedAndSelectedFile, persons, receptionBox, updateData, getSupportingDocumentTypeByPerson, files, getCategory, participation, categoryLabel, ...props}) {

    const [loading, setLoading] = useState(false);
    const [supportingDocumentCategory, setSupportingDocumentCategory] = useState('');
    const [participantTitle, setParticipantTitle] = useState('');
    const [description, setDescription] = useState('');
    const [personId, setPersonId] = useState('');
    const [category, setCategory] = useState('');

    useEffect(()=>{
        switch (supportingDocumentCategory) {
            case "Justificatif_identite_Adulte": setCategory("Justificatif_identite_Adulte")
                break;
            case "Justificatif_identite_Enfant": setCategory("Justificatif_identite_Enfant")
                break;
            case "RFR": setCategory("RFR")
                break;
            case "revenus": setCategory("revenus")
                break;
            case "piece_identite": setCategory("piece_identite")
                break;
            case "Documents_complementaires": setCategory("Documents_complementaires")
                break;
            case "carte_mobilite": setCategory("carte_mobilite")
                break;
            case "Desunion": setCategory("Desunion")
                break;
            case "Union": setCategory("Union")
                break;
            case "Mode_garde": setCategory("Mode_garde")
                break;
            case "Deces": setCategory("Deces")
                break;
            default: setCategory(null)
        }
    },[supportingDocumentCategory])

    function createAndUploadSupportingDocument() {
        setLoading(true);
        const fileToUpload = files;

        const newSupportingDocument = {
            surveyParticipationId: participation.id,
            personId: personId,
            category: category,
            participantTitle: participantTitle,
            description: description,
            status: 'a_fournir'
        };
        const participationId = participation.id;

        onlineProcessesService.createSupportingDocument({ participationId : participationId, personRecordId : personId }, newSupportingDocument)
            .then(response => {
                const supportingDocumentId = response.salesforceId;
                return uploadFiles({
                    participationId,
                    personId,
                    supportingDocumentId,
                    participantTitle,
                    description,
                    files: fileToUpload
                })
            })
            .then(() => {
                updateData();
                setOpen(false);
                setLoading(false);
            })
            .catch(err => console.error(err));
    }

    function uploadFiles({participationId, personId, supportingDocumentId}){

        if(!personId || !supportingDocumentId){
            console.warn('params ou files manquant')
            return Promise.reject("Params ou files manquants");
        }

        if((!Array.isArray(files) || files.length === 0) && !receptionBoxDisplay) {
            return Promise.resolve({ skipped: true });
        }

        const formData = new FormData();
        files.forEach((item, i)=>{
            const fieldName = i === 0 ? 'file' : `file${i +1}`;
            let fileToUpload = item;

            if(typeof item === "string" && item.startsWith('data:')){
                fileToUpload = dataUrlToFile(item, fieldName);
            } else if(item && typeof item === 'object' && item.src?.startsWith('data:')){
                fileToUpload = dataUrlToFile(item.src, item.alt || fieldName);
            }
            formData.append(fieldName, fileToUpload);
        })

        return onlineProcessesService.uploadSupportingDocumentFile({ participationId, personRecordId : personId, supportingDocumentId }, formData)
        .then(()=>{
            handlePageAssignment(supportingDocumentId, files);
        })
    }
    
    return (
    <>
        {loading && <QuadralLoaderProvider/>}
        {open && (
            <QuadralModal
                title={ receptionBoxDisplay ?
                    ( <span>Association à une nouvelle pièce justificative</span> ) : 
                    ( <span>Créer une nouvelle pièce justificative</span> ) }
                // icon={<FontAwesomeIcon icon={faUserPen}/>}
                open={open}
                setOpen={setOpen}
                noButton
                action={
                    <>
                        <QuadralButton
                            size="medium"
                            color="error"
                            variant="outlined"
                            onClick={() => setOpen(false)}
                        >
                            Annuler
                        </QuadralButton>
                        <QuadralButton 
                            size="medium" 
                            color="success" 
                            variant="outlined"
                            disabled={(files?.length === 0 && receptionBoxDisplay) || (!supportingDocumentCategory || !personId)}
                            onClick={() => createAndUploadSupportingDocument()}
                        >
                            Confirmer
                        </QuadralButton>
                    </>
                }
            >
                <QuadralContainer>
                    {(files?.length === 0 && receptionBoxDisplay) && (
                        <span className="text-weight-bold">Veuillez sélectionner des pages avant d'effectuer cette opération</span>
                    )}
                    <span>Veuillez sélectionner la catégorie de la pièce justificative et la personne correspondant à ces pièces</span>
                    <div className="selections">
                        <QuadralForm>
                            <QuadralAutocomplete
                                label="Personne"
                                options={persons || []}
                                value={persons?.find((p) => p.id === personId) ?? null}
                                getOptionLabel={(p) => `${p.firstname} ${p.lastname}`}
                                onChange={(event, person) => {
                                    setPersonId(person?.id ?? '');
                                }}
                                md={6}
                                sm={6}
                                disabled={files?.length === 0 && receptionBoxDisplay}
                                required
                            />
                            <QuadralAutocomplete
                                label="Catégorie"
                                options={categoryLabel || []}
                                value={categoryLabel?.find((c) => c.code === supportingDocumentCategory) ?? null}
                                getOptionLabel={(category) => getCategory({category: category.code})}
                                onChange={(event, category) => {
                                    setSupportingDocumentCategory(category?.code ?? '');
                                }}
                                md={6}
                                sm={6}
                                disabled={files?.length === 0 && receptionBoxDisplay}
                                required
                            />
                        </QuadralForm>
                        <QuadralTypography variant="informationText"> 
                            <FontAwesomeIcon icon={faInfoCircle} style={{ padding: '0 0.25rem' }}/>
                            Pour les pièces justificatives de type Revenu fiscal de référence et Justificatif d'identité enfant ou adulte, la plateforme pré-remplit le titre et la description de la nouvelle pièce justificative. Pour tous les autres types de pièces justificatives, veuillez renseigner les informations ci-dessous s'il vous plaît. :
                        </QuadralTypography>
                        <QuadralForm>
                            <QuadralTextField 
                                label="Titre participant"
                                value={participantTitle}
                                onChange={(value) => setParticipantTitle(value)}
                                disabled={files?.length === 0 && receptionBoxDisplay}
                                md={12}
                                sm={12}
                            />
                            <QuadralTextField
                                label="Description"
                                value={description}
                                onChange={(value) => setDescription(value)}
                                disabled={files?.length === 0 && receptionBoxDisplay}
                                multiline
                                rows={4}
                                md={12}
                                sm={12}
                            />
                        </QuadralForm>
                    </div>
                    <div>
                        {(files?.length > 0 && receptionBoxDisplay) && (<>
                            <div className="main" style={{display: 'flex', margin: '20px 0 30px 0'}}>
                                <div className="modal_unattachedFile-wrapper">
                                        {files?.map((page,index)=>(
                                            <div key={index} className="modal_unattachedFile_card"> 
                                                {page.src && (
                                                    <iframe
                                                        className="modal_unattachedFile"
                                                        src={page.src}
                                                        title={`PDF - Page ${index + 1}`}
                                                        style={{
                                                            width:"200px",
                                                            height:"300px"
                                                        }}
                                                    ></iframe>
                                                )}
                                            </div>
                                        ))}
                                </div>                                    
                            </div>
                        </>)}
                    {(files?.length === 0 && receptionBoxDisplay) && (
                        <span>Veuillez sélectionner des pages avant d'effectuer cette opération</span>
                    )}
                    </div>
                </QuadralContainer>
            </QuadralModal>
        )}
    </>
  );
}